export const config = {
  BACKEND_URL: import.meta.env.VITE_BACKEND_URL,
  VITE_MS_CLIENT_ID: import.meta.env.VITE_MS_CLIENT_ID,
  VITE_MS_AUTHORITY: import.meta.env.VITE_MS_AUTHORITY,
};
